class APIS {
	apis() {
		return {
			createTag: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/tag/insert'
			},
			fetchTag: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/tags'
			},
			editTag: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/tag/update'
			},
			deleteTag: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/tag/delete'
			}
		};
	}
}

export default new APIS();
